import { type FunctionComponent } from 'react';

import { Button, LoadingSpinner } from '@kanda-libs/ks-design-library';

import { KandaEtikaBadge } from 'components';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useEtikaSignDocuments from './useEtikaSignDocuments';

const EtikaSignDocuments: FunctionComponent = () => {
  const { isLoading, link } = useEtikaSignDocuments();

  return (
    <>
      <PleaseWaitOverlay
        icon="rotate"
        header={<KandaEtikaBadge />}
        title="Almost done... we're redirecting you to Etika to submit your application."
        labelLine1="Not been redirected? Click the button below"
        isLoading={isLoading}
      />
      <LoadingSpinner stroke="purple-300" className="mx-auto mt-8" />
      {link && (
        <a href={link} className="mx-auto mt-8">
          <Button.Text
            id="etika-lender-decision"
            label="Continue to Etika"
            className="w-64"
            disabled={isLoading}
            isLoading={isLoading}
          />
        </a>
      )}
    </>
  );
};

export default EtikaSignDocuments;
